import PropTypes from 'prop-types';
import React from 'react';

import Api from '../../../api/Api';

import Availability from '../../../models/Availability';
import HomeModel from '../../../models/Home';
import UserModel from '../../../models/User';
import Utils from '../../../utils/utils';

import MainView from './MainView';
import Success from './Success';

export default class Contact extends React.PureComponent {
    static propTypes = {
        user: PropTypes.instanceOf(UserModel).isRequired,
        home: PropTypes.instanceOf(HomeModel).isRequired,
        availabilities: PropTypes.arrayOf(PropTypes.instanceOf(Availability)),
        showModal: PropTypes.bool.isRequired,
        onCloseModal: PropTypes.func.isRequired
    };

    static defaultProps = {
        availabilities: []
    };

    static nbConversationsObjective = 10;
    static nbGPObjective = 50;

    constructor(props) {
        super(props);

        this.state = {
            step: 'form',
            nbConversations: null,
            search: null
        };

        this.onMessageSent = this.onMessageSent.bind(this);
        this.updateLastSearchFromContactPopup = this.updateLastSearchFromContactPopup.bind(this);
    }

    componentDidMount() {
        this.loadLastSearch();
    }

    // preset last date range based on user's last search
    loadLastSearch() {
        Api.Search.getLastSearch().then((search) => {
            if (search) {
                this.setState({
                    search
                });
            } else {
                Api.Search.getLocalLastSearch(this.props.user.get('id')).then((result) => {
                    this.setState({
                        search: result
                    });
                });
            }
        });
    }

    updateLastSearchFromContactPopup(lastSearch) {
        this.setState({
            search: Utils.deepclone(lastSearch)
        });
    }

    onMessageSent() {
        this.setState({ step: 'success' });
    }

    render() {
        const { home, user, availabilities, showModal, onCloseModal } = this.props;

        if (this.state.step === 'success') {
            return (
                <Success
                    showModal={showModal}
                    onCloseModal={onCloseModal}
                    home={home}
                    nbConversations={this.state.nbConversations}
                    nbConversationsObjective={Contact.nbConversationsObjective}
                    nbGPObjective={Contact.nbGPObjective}
                    search={this.state.search}
                />
            );
        } else if (this.state.step === 'form') {
            return (
                <MainView
                    showModal={showModal}
                    onCloseModal={onCloseModal}
                    user={user}
                    home={home}
                    availabilities={availabilities}
                    onMessageSent={this.onMessageSent}
                    updateLastSearch={this.updateLastSearchFromContactPopup}
                />
            );
        }
    }
}
